import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router";
import { getListDetailsPath } from "../../../shared/component/get-list-details-path";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

interface IOwnProps {
    disabled: boolean;
    listId: number;
    children: ReactNode;
}

const SublistItemCell = (props: IOwnProps & IWithClassName) => {
    if (props.disabled) {
        return (
            <Typography className={props.className}>
                {props.children}
            </Typography>
        );
    }

    return (
        <Link
            className={props.className}
            to={getListDetailsPath(String(props.listId))}
        >
            {props.children}
        </Link>
    );
};

export default styled(SublistItemCell)(({ theme }: IWithThemeProps) => ({
    textDecoration: "none",
    color: theme?.palette.detailsPane.textColor,
    fontSize: "1rem",
}));
